














import { Component, Vue } from "vue-property-decorator";
import MaskLayer from "./maskLayer.vue";
import { MaskModule, ConfigModule } from "@/store/index";

@Component({
  components: {
    MaskLayer
  }
})
export default class AlertMask extends Vue {
  /* -------------- data ------------- */

  /* -------------- computed ------------- */
  get maskActive () {
    // 遮罩显示状态
    return MaskModule.maskActive;
  }

  get maskInnerHtml () {
    // 遮罩显示内容
    return MaskModule.maskInnerHtml;
  }

  get categoryForUnderstoodTitle () {
    return ConfigModule.categoryForUnderstoodTitle;
  }

  /* -------------- methods ------------- */

  /**
   * @description: 关闭遮罩
   */

  closeMask () {
    MaskModule.closeMask();
  }
}
